import React from 'react';
import { makeStyles, } from '@mui/styles';
import {
  Button,
  Grid,
  IconButton,
} from '@mui/material';
import { Close, } from '@mui/icons-material';
import { Alert, } from '@mui/lab';
import Loading from '../../Loading';
import { DataSourceTable, } from '../DataSourceTable';
import { NoDataComponent, } from '../../NoDataComponent';
import { useAuth, } from '../../../context';
import { useDSCalls, } from '../../../hooks';
import { useNavigate, } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  paddingTop: { paddingTop: '20px', },
});

function DataSourceDashboard() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { isAuthorized, } = useAuth();
  const [canWrite,] = React.useState(isAuthorized('ADAPTIVE_DS_WRITE'));

  const navigationData = {
    component: 'dataSources',
    header: 'No Data Sources',
    text1: 'You have not created a data source yet',
    text2: 'Create a data source to get started',
    buttonText: 'Add data source',
    route: '/data-source/add',
  };

  const { dataSources, loading, error, deleteDataSource, } = useDSCalls();

  if (loading && !dataSources) {
    return <Loading/>;
  }

  if (!loading && dataSources && dataSources.length === 0) {
    return <NoDataComponent data={navigationData}/>;
  }


  return (
    <div className={classes.root}>
      <Grid className={classes.root}>
        <Grid container>
          {error && (
            <Grid item xs={4}>
              <Alert
                severity="error"
                style={{ marginLeft: '20px', }}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                  >
                    <Close fontSize="inherit"/>
                  </IconButton>
                }
              >
                {error}
              </Alert>
            </Grid>
          )}
        </Grid>
        <Grid item>
          {canWrite &&
            <Button
              // style= { { marginTop : '15px', } }
              className={classes.root}
              variant="contained"
              color="primary"
              onClick={() => {
                navigate('/data-source/add');
              }}
            >
              Add data source
            </Button>
          }
          <DataSourceTable dataSources={dataSources} loading={loading} deleteDataSource={deleteDataSource}/>
        </Grid>
      </Grid>
    </div>
  );
}

export default DataSourceDashboard;
